import React from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import ServiceCard from "../components/ServiceCard";
import Seo from "../components/Seo";
import services from "../data/services";
import "../styles/pages/home.css";

function Home() {
    return (
        <main>
            <Seo
                title="Dahlia Health Care Services | Healthcare Staffing, Training & Care Services UK"
                path="/"
                description="Dahlia Health Care Services provides healthcare staffing and recruitment, mental health staff training, domiciliary care including live-in support, children's services, and secure transport across the UK."
                keywords="healthcare staffing UK, healthcare recruitment, mental health staff training, domiciliary care, live-in care, children's services, secure transport UK"
            />

            <Hero />

            <section className="section section--top-tight">
                <div className="container">
                    <div className="feature-strip">
                        <div>✔ Qualified and dependable professionals</div>
                        <div>✔ Person-centered and safeguarding-led support</div>
                        <div>✔ Flexible services for families and organizations</div>
                        <div>✔ High standards of care and compliance</div>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="section-heading">
                        <div>
                            <p className="eyebrow">Core Services</p>
                            <h2>Practical support designed around real needs</h2>
                            <p>
                                We support healthcare providers, communities, and families through responsive, compassionate, and professionally delivered services.
                            </p>
                        </div>
                        <Link to="/services" className="text-link">View all services</Link>
                    </div>

                    <div className="card-grid">
                        {services.map((service) => (
                            <ServiceCard key={service.title} {...service} />
                        ))}
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="split-showcase">
                        <div className="split-showcase__card split-showcase__card--dark">
                            <p className="eyebrow eyebrow--light">Why Choose Us</p>
                            <h2>Professional, thoughtful, and dependable at every stage</h2>
                            <p>
                                We combine practical expertise with compassion, delivering services that are reliable, respectful, and adaptable to a wide range of support needs.
                            </p>
                        </div>
                        <div className="split-showcase__grid">
                            <div>Fast, responsive support and communication</div>
                            <div>Experienced teams with specialist understanding</div>
                            <div>Flexible packages built around real needs</div>
                            <div>Strong focus on wellbeing, dignity, and safety</div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="container">
                    <div className="process-grid">
                        <div className="process-card">
                            <span>01</span>
                            <h3>Discuss Your Needs</h3>
                            <p>We begin by understanding what support, staffing, or care arrangement you need and when you need it.</p>
                        </div>
                        <div className="process-card">
                            <span>02</span>
                            <h3>Create the Right Plan</h3>
                            <p>We recommend a service pathway shaped around your priorities, timelines, and individual circumstances.</p>
                        </div>
                        <div className="process-card">
                            <span>03</span>
                            <h3>Deliver With Confidence</h3>
                            <p>Our team provides ongoing support with professionalism, responsiveness, and a strong focus on outcomes.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section section--last">
                <div className="container">
                    <div className="cta-box">
                        <p className="eyebrow">Start the conversation</p>
                        <h2>Ready to talk about how we can support you?</h2>
                        <p>
                            Whether you need temporary staff, specialist training, home-based care, children’s support, or secure transport, we are ready to help.
                        </p>
                        <div className="cta-box__actions">
                            <Link to="/contact" className="btn btn--primary">Contact Us</Link>
                            <Link to="/about" className="btn btn--secondary">Learn About Us</Link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Home;